import React, { Component, MouseEvent } from "react";
import classnames from "classnames";

import * as styles from "./DataTableRow.scss";
import { IDataTableColumn } from "./IDataTableColumn";

export interface IDataTableRowProps<T> {
    index: number;
    row: T;
    columns: IDataTableColumn<T>[];
    onClicked?: (row: T) => void;
    testId?: string | number;
}

export class DataTableRow<T> extends Component<IDataTableRowProps<T>> {
    public render() {
        const { index: rowIndex, row, columns, testId } = this.props;

        return (
            <tr
                className={classnames(
                    styles["data-table-row"],
                    this.props.onClicked && styles.clickable,
                )}
                onClick={this.onClick}
                data-testid={`data-row-${testId ?? rowIndex}`}
            >
                {columns.map((column, columnIndex) => (
                    <td
                        key={columnIndex}
                        className={classnames(
                            column.className,
                            column.hideBelow &&
                                styles[`hide-below-${column.hideBelow}`],
                        )}
                        data-testid={`data-column-header-${
                            typeof column.header === "string"
                                ? column.header
                                : columnIndex
                        }`}
                    >
                        {column.row(row, rowIndex)}
                    </td>
                ))}
            </tr>
        );
    }

    private onClick = (event: MouseEvent) => {
        const { row, onClicked } = this.props;
        if (!onClicked) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        onClicked(row);
    };
}
